var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.lob === "SI"
        ? [
            !_vm.masterFlag
              ? _c("si-tab-container", {
                  ref: "siTabContainer",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": _vm.viewSource
                  }
                })
              : _vm._e(),
            _vm.masterFlag
              ? _c("si-tab-lcl-container", {
                  ref: "siTabLclContainer",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": _vm.viewSource
                  }
                })
              : _vm._e()
          ]
        : _vm._e(),
      _vm.lob === "SE"
        ? [
            !_vm.masterFlag
              ? _c("tab-container", {
                  ref: "tabContainer",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": _vm.viewSource
                  }
                })
              : _vm._e(),
            _vm.masterFlag
              ? _c("tab-lcl-container", {
                  ref: "tabLclContainer",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": _vm.viewSource
                  }
                })
              : _vm._e()
          ]
        : _vm._e(),
      _vm.lob === "RE" || _vm.lob === "RI"
        ? [
            !_vm.masterFlag
              ? _c("re-tab-container", {
                  ref: "reTabContainer",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": _vm.viewSource
                  }
                })
              : _vm._e(),
            _vm.masterFlag
              ? _c("re-tab-lcl-container", {
                  ref: "reTabLclContainer",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": _vm.viewSource
                  }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }